import * as yup from 'yup';
export const addHotelValidation = yup.object({
  name: yup.string().required('*required'),
  address: yup
    .object()
    .test('Test agent', 'agent is required', (value) => value?.address),
  numberOfRooms: yup
    .number()
    .min(1, 'must be greater than or equal to 1')
    .required('*required'),
  type: yup.string().required('*required'),
  hotelRating: yup.string().required('*required'),
  facilities: yup.array(),
  agent: yup
    .object()
    .test('Test agent', 'agent is required', (value) => value?.name),
  state: yup.string().required('*required'),
  description: yup.string().required('*required')
});

export const editHotelValidation = yup.object({
  name: yup.string(),
  numberOfRooms: yup.number().min(1, 'must be greater than or equal to 1'),
  type: yup.string(),
  hotelRating: yup.string(),
  facilities: yup.array(),
  description: yup.string()
});

export const addHotelDetailsValidation = yup.object({
  roomType: yup.string().required('*required'),
  noOfRooms: yup.number().required('*required'),
  price: yup.string().required('*required')
});
